import styled from "@emotion/styled";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { ExtraHeaderBaseProps } from "@kaltura/mediaspace-shared-media-list";
import { IconButton, Tooltip } from "@kaltura/ds-react-components";
import { Refresh24Icon } from "@kaltura/ds-react-icons";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { EmptyRecycleBinButton } from "./EmptyRecycleBinButton";

export type RecycleBinHeaderProps = ExtraHeaderBaseProps & {
    emptyBinUrl: string;
};

/**
 * RecycleBinHeader component - displays action buttons when no entries are selected
 */
export const RecycleBinHeader = ({ onReload, selectedEntries, emptyBinUrl }: RecycleBinHeaderProps) => {
    const sendButtonAnalytics = useButtonAnalytics();

    const reloadList = () => {
        sendButtonAnalytics("Refresh recycle bin", ButtonClickAnalyticsType.LOAD, undefined, "Recycle Bin");
        onReload();
    };

    return selectedEntries && selectedEntries?.length > 0 ? null : (
        <ActionsContainer>
            <Tooltip title={translate("Reload Recycle Bin")}>
                <IconButton
                    variant={"borderless"}
                    color={"secondary"}
                    aria-label={translate("Reload Recycle Bin")}
                    onClick={reloadList}
                    data-testid={"recycle-bin-empty-recycle-bin-button"}
                >
                    <Refresh24Icon />
                </IconButton>
            </Tooltip>
            <EmptyRecycleBinButton onReload={onReload} url={emptyBinUrl} />
        </ActionsContainer>
    );
};

const ActionsContainer = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
}));
